<template>
  <div :class="classNames">
    <a
      v-if="hasMobileApp"
      :href="linkDefault"
      class="cta store-badges__item js-adjust-link"
      data-button-code="body-20200223-store_badges"
      data-platform="has_mobile_app"
    >
      <div class="store-badges__default-button-inner">
        <sprite class="store-badges__default-button-sprite" id="app/open-external" />
        <span class="store-badges__default-button-label">
          {{ $t("continueInApp") }}
        </span>
      </div>
    </a>

    <template v-else>
      <store-badge
        v-if="seesIosLink"
        @click="$emit('iosBadgeClick')"
        :link="linkIos"
        :cta-style="true"
        platform="ios"
        button-code="body-20200223-store_badges"
        class="store-badges__item w-full js-adjust-link"
      />
      <store-badge
        v-if="seesAndroidLink"
        :link="linkAndroid"
        :cta-style="true"
        platform="android"
        button-code="body-20200223-store_badges"
        class="store-badges__item w-full js-adjust-link"
      />
    </template>
  </div>
</template>

<script>
import "/wds/sprites/app/open-external.svg"
import bemBlockModifiers from "@/utils/bem-block-modifiers"
import StoreBadge from "@/shared/store-badges/store-badge"
import Sprite from "@/shared/sprite"

export default {
  name: "StoreBadges",
  components: {
    StoreBadge,
    Sprite
  },
  props: {
    hasMobileApp: { type: Boolean, default: false },
    linkDefault: { type: String, default: "#" },
    linkIos: { type: String, default: "#" },
    linkAndroid: { type: String, default: "#" },
    isAndroid: { type: Boolean, default: null },
    isIos: { type: Boolean, default: null }
  },
  computed: {
    classNames() {
      return bemBlockModifiers("store-badges", this.modifiers)
    },
    seesAndroidLink() {
      return !this.isIos // Covers android and desktop
    },
    seesIosLink() {
      return !this.isAndroid // Covers ios and desktop
    }
  },
  i18n: {
    messages: {
      en: { continueInApp: "Continue in the app" },
      de: { continueInApp: "Weiter in der App" }
    }
  }
}
</script>

<style lang="scss">
.store-badges {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__item {
    margin-bottom: $spacing-16;

    &:not(:only-child) {
      flex-grow: 1;
    }

    @include media(min-width, l) {
      &:not(:only-child) {
        min-width: auto;
      }

      &:not(:last-child) {
        margin-right: grid-gutter(l);
      }
    }
  }

  &__default-button-inner {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__default-button-sprite {
    flex-shrink: 0;
    margin-right: $spacing-8;
  }

  &__default-button-label {
    flex-grow: 0;
  }

  @include media(min-width, l) {
    flex-direction: row;
  }
}
</style>
